import axios from "axios";

export const baseURL = axios.create({
    baseURL: `https://api.magodlaser.in/wm/`,
});
// export const baseURL = axios.create({
//     baseURL: `http://localhost:8081/wm/`,
// });
